import * as ActionTypes from "../../actions";
var goalRows = function goalRows() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_GOALS_SUCCESS:
      state = [];
      if (action.response._embedded) state.push.apply(state, action.response._embedded.goals);
      return state;
    default:
      return state;
  }
};
export default goalRows;